import { render, staticRenderFns } from "./StudioTeam.vue?vue&type=template&id=107f36ad&"
import script from "./StudioTeam.vue?vue&type=script&lang=js&"
export * from "./StudioTeam.vue?vue&type=script&lang=js&"
import style0 from "./StudioTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports